import React from 'react';
import apiService from '../../APIService';



const MessageRedirect = (props) => {

  
    let textData = props.item && props.item.text_data && JSON.stringify(props.item.text_data)

    const code= props.item && props.item.code
    const size =  props.item && props.item.text_data && props.item.text_data.size 
    const width=size && size.width;
    const height= size && size.height;
    const url =props.item.url;
    const data = props.item && props.item.text_data
    // const sendUrl = `https://uat.help.tatasky.com/chatbot/tatasky/predirect?url=${url}&data=${data}`
    // const sendUrl = `https://uat.help.tatasky.com/chatbot/tatasky/predirect?url=${url}`
    // console.log("redirectprops",props,data,textData,width,height,props.disable)

    const handleClick = (url,data) => {

      // console.log("handletrdirect",url,data,JSON.parse(data))
      apiService.messageRedirect(url,JSON.parse(data)).then(response => {
        console.log("messageredirectresponse",response.data);
      })
    }


    const handleSubmit = (url) => {
      // console.log("handlesubmit",url)
      // window.open(
      //   url,
      //   "_blank",
      //   `toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=${width},height=${height}`
      // );
    }

    return (

      <span className={!props.disable ? "chat-label action-tab ":"chat-labelnohover action-tab"} id="main-tab1" >
        {data && data.data ?
      <form target="targetWindow"  action={!props.disable && url}  method="POST">
     <input type="hidden" name={Object.keys(data.data)[0]} value={data.data[Object.keys(data.data)[0]]} />
         <input type="submit" value={props.item.text} onClick={() => {
          if(!props.disable)
         { props.handleClick(code); props.setTextOnClick(props.item.text);handleSubmit(url)
          // window.open(!props.disable && url,
          //   'targetWindow',
          //   `toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=${width},height=${height}`); return false 
          }} } style={{ color: props.disable ?'grey':'inherit',border:'none',background:'none',fontFamily: "VoltePlay-Medium, sans-serif",
          fontSize: "15px"}} /></form>: (
          data && data !== "undefined" ?
              <form  target="_blank" action={!props.disable && url} method="POST">
                {/* <input type="hidden" name="url" value={url} /> */}
                <input type="hidden" name={Object.keys(data)[0]} value={data[Object.keys(data)[0]]} />
                <input     type="submit" value={props.item.text} onClick={() => {
                  if (!props.disable) { props.handleClick(code); props.setTextOnClick(props.item.text); }
                }}
                 style={{fontFamily: "VoltePlay-Medium, sans-serif",
                 fontSize: "15px", color: props.disable ? 'grey' : 'inherit',border:'none',background:'none' }} />
              </form>
            :
            (<a  
                onClick={() => {
              if(!props.disable)
             { props.handleClick(code); props.setTextOnClick(props.item.text);} }}
              href={!props.disable &&  props.item.url} style={{ color: props.disable ?'grey':'inherit',fontFamily: "VoltePlay-Medium, sans-serif",
              fontSize: "15px" }} target="_blank" >{props.item.text}</a>)
        )}</span>
    )
}


export default MessageRedirect;